module.exports = __webpack_public_path__ + "static/media/reedNwnAutonRo1021.00ba6531.ico";